<template>
	<div>
		<modalconfirm ref="modalconfirmTO" @action="proccessTO"/>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Transfer Stok Warehouse</div>
		</div>
		<div class="pt-3" v-if="loading">
			<v-card elevation="0" width="1000" height="100">
				<template>
					<vcl :width="300" :height="25">
						<rect x="0" y="5" rx="1" ry="1" width="80" height="7" />
						<rect x="85" y="5" rx="1" ry="1" width="20" height="7" />
						<rect x="110" y="5" rx="1" ry="1" width="20" height="7" />
						<rect x="0" y="20" rx="1" ry="1" width="280" height="5" />
					</vcl>
				</template>
			</v-card>
			<v-card elevation="0" width="1000" height="65" v-for="i in 10" :key="i">
				<template>
					<vcl :width="300" :height="70">
						<rect x="0" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="0" y="11" rx="1" ry="1" width="50" height="5" />
						<rect x="70" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="70" y="11" rx="1" ry="1" width="50" height="5" />
						<rect x="140" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="140" y="11" rx="1" ry="1" width="50" height="5" />
						<rect x="210" y="3" rx="1" ry="1" width="25" height="5" />
						<rect x="210" y="11" rx="1" ry="1" width="50" height="5" />
					</vcl>
				</template>
			</v-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<div class="ml-4">
							<v-tabs color="primary" background-color="deep-purple lighten-5" class="change-display" height="40">
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-show="dropfilter">
					<v-col cols="12" class="px-4">
						<v-row>
							<v-col cols="12" md="3">
								<v-text-field outlined dense hide-details label="Kode Transfer" v-model="to_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="3">
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalTO)" label="Tanggal Transfer" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
									</template>
									<v-date-picker locale="id" range color="primary" v-model="tanggalTO"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="to_from_warehouse_id.value" :items="listWarehouse" label="Asal Pengiriman" class="width-0" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="warehouse_name" item-value="warehouse_id" outlined dense hide-details v-model="to_to_warehouse_id.value" :items="listWarehouse" label="Tujuan Pengiriman" class="width-0" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete item-text="status" item-value="code" outlined dense hide-details v-model="to_status.value" :items="status_list" label="Status Transfer" class="width-0" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="6">
							</v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="ml-2 text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="primary" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table loading :headers="headers" :items="listTO" hide-default-footer :options.sync="option" :server-items-length="toPagination.total_data" disable-pagination>
					<template v-slot:item.to_status_created_datetime="{ item }">
						<div class="pt-2">{{ item.to_status_created_datetime |tanggalid }}</div>
						<div class="pt-3 pb-3">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn x-small dense text color="grey darken-1" v-bind="attrs" v-on="on" @click="printTO(item.to_from_warehouse_id, item.to_code)"><v-icon>mdi-printer</v-icon></v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:item.to_code="{ item }">
						<div>{{ item.to_code }}</div>
					</template>
					<template v-slot:item.from_warehouse_name="{ item }">
						<div>{{ item.from_warehouse_name }}</div>
						<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.from_warehouse_mobilephone }}</span></div>
					</template>
					<template v-slot:item.to_warehouse_name="{ item }">
						<div>{{ item.to_warehouse_name }}</div>
						<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.to_warehouse_mobilephone }}</span></div>
					</template>
					<template v-slot:item.to_status="{ item }">
						<div class="pt-2 text-capitalize">{{ item.to_status | toStatusTOWH }}</div>
						<div class="pt-2 pb-2">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item.to_code)">
										<v-icon dark>mdi-text-box-search</v-icon>
									</v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!toPagination">
							<loading-data></loading-data>
						</div>
						<div class="py-3" v-else>
							<not-found></not-found>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card outlined v-if="listTO.length == 0 && toPagination">
					<div class="py-3">
						<not-found></not-found>
					</div>
				</v-card>
				<v-card outlined v-else-if="listTO.length == 0 && !toPagination">
					<div class="py-3">
						<loading-data></loading-data>
					</div>
				</v-card>
				<v-card v-else class="mb-3" outlined v-for="to in listTO" :key="to.to_id">
					<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Transfer {{ to.to_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small text depressed class="primary" @click="printTO(to.to_from_warehouse_id, to.to_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Tanggal </div>
									<div class="subtitle-2">{{ to.to_status_created_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm6 md2>
									<div class="body-2 oppacity-75">Asal Pengiriman </div>
									<div class="subtitle-2">{{ to.from_warehouse_name }}</div>
								</v-flex>
								<v-flex xs6 sm6 md2>
									<div class="body-2 oppacity-75">Tujuan Pengiriman</div>
									<div class="subtitle-2">{{ to.to_warehouse_name }}</div>
								</v-flex>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ to.to_status | toStatusTOWH }}</div>
								</v-flex>
								<v-flex xs6 sm3 md2>
									<div class="pt-1">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(to.to_code)" class="mr-2">
													<v-icon dark>mdi-text-box-search</v-icon>
												</v-btn>
											</template>
											<span>Detail</span>
										</v-tooltip>
									</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
				</v-card>
			</div>
			<div class="pt-5">
				<v-row v-if="toPagination">
					<v-spacer></v-spacer>
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" @input="changePage" :length="toPagination.total_page" total-visible="7" circle class="d-flex justify-end"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalPrint from '@/views/MLwarehouse/to/PrintTO'
import modalDetail from '@/views/MLwarehouse/to/DetailTO'
import {mapActions,  mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
			cardDisplay: false,
			menu: false,
			loading: true,
			transfer_type: 'in',
			tanggalTO: [],
			to_code: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'to_code'
			},
			to_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'to_status_created_datetime'
			},
			to_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'to_status'
			},
			to_from_warehouse_id: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'to_from_warehouse_id'
			},
			to_to_warehouse_id: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'to_to_warehouse_id'
			},
			sortBy: 'to_id',
			sortDir: 'DESC',
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			dropfilter: false,
			dialog: false,
			dialogPrint: false,
			dialogConfirm: false,
			headers: [
			{ text: 'Tanggal', value: 'to_status_created_datetime' },
			{ text: 'Kode Transfer', sortable: true, value: 'to_code'},
			{ text: 'Asal Pengiriman', value: 'from_warehouse_name'},
			{ text: 'Tujuan Pengiriman', value: 'to_warehouse_name'},
			{ text: 'Status', value: 'to_status' },
			],
			params:[],
			procces_to_id: '',
			toProccess : '',
		}
	},
	computed: {
		...mapState('to', ['listTO', 'toPagination', 'TOStatus', 'listWarehouse']),
		...mapState('auth', ['userData']),

		status_list() {
			return this.TOStatus.map( (el) => {
				return {
					code: el,
					status: this.$options.filters.toStatusTOWH(el)
				}
			})
		}
	},
	methods: {
		...mapActions('to', ['getTOAll', 'getTOIn', 'getTOOut', 'approveTO', 'rejectTO', 'deleteTO', 'getDetailTO', 'getTOStatus', 'exportTOWarehouse', 'exportTOIN', 'exportTOOUT', 'getOptionWarehouseAll', 'exportTOAll']),
		...mapMutations('to', ['clearDataTO']),
		...mapActions('common', ['getLetterHeader']),
		...mapMutations(['setOverlay']),

		exportData() {
			this.exportTOAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changetype(type) {
			this.transfer_type = type
			this.resetFilter()
		},
		getData() {
			this.getTOAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter() {
			this.to_code.value = ''
			this.to_date.value = ''
			this.to_status.value = ''
			this.to_from_warehouse_id.value = ''
			this.to_to_warehouse_id.value = ''
			this.page = 1
			this.getData()
		},
		cari() {
			this.params = []
			if (this.to_code.value)
				this.params.push(this.to_code)
			if (this.to_date.value) {
				if (this.to_date.value.length > 1) {
					this.to_date.value.sort()
					let date = this.to_date.value.join('::')
					this.to_date.value = date
				}
				this.params.push(Object.assign({}, this.to_date))
			}
			if (this.to_status.value)
				this.params.push(this.to_status)
			if (this.to_from_warehouse_id.value)
				this.params.push(this.to_from_warehouse_id)
			if (this.to_to_warehouse_id.value)
				this.params.push(this.to_to_warehouse_id)
			this.page = 1
			this.getData()
		},
		approve(val) {
			this.procces_to_id = val
			this.toProccess = 'approve'
			let msg = "Yakin akan memproses Transfer Stok ini?"
			this.$refs.modalconfirmTO.showConfirm()
			this.$refs.modalconfirmTO.setMessage(msg)
		},
		reject(val) {
			this.procces_to_id = val
			this.toProccess = 'reject'
			let msg = "Yakin akan membatalkan Transfer Stok ini?"
			this.$refs.modalconfirmTO.showConfirm()
			this.$refs.modalconfirmTO.setMessage(msg)
		},
		hapus(val) {
			this.procces_to_id = val
			this.toProccess = 'delete'
			let msg = "Yakin akan menghapus Transfer Stok ini?"
			this.$refs.modalconfirmTO.showConfirm()
			this.$refs.modalconfirmTO.setMessage(msg)
		},
		async proccessTO() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmTO.hideConfirm()
			if (this.toProccess == 'approve') {
				await this.approveTO(this.procces_to_id)
			} else if (this.toProccess == 'reject') {
				await this.rejectTO(this.procces_to_id)
			} else if (this.toProccess == 'delete') {
				await this.deleteTO(this.procces_to_id)
			}
			await this.getData()
			await this.setOverlay(false)
		},
		getDetail(code) {
			this.getDetailTO(code).then(()=> {
				this.dialog = true
			})
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.page = 1
			this.limit = limit
			this.getData()
		},
		async printTO(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailTO(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Transfer Stok`)
		await this.getOptionWarehouseAll()
		await this.getData()
		await this.getTOStatus()
		this.loading = await false
	},
	beforeDestroy() {
		this.clearDataTO()
	},
	watch: {
		tanggalTO(val) {
			this.to_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>